export default "__VITE_ASSET__CAZiUWZt__"